import script from "./StoreAdminHours.vue?vue&type=script&setup=true&lang=js"
export * from "./StoreAdminHours.vue?vue&type=script&setup=true&lang=js"

import "./StoreAdminHours.vue?vue&type=style&index=0&id=7284ee0b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7284ee0b"]])

export default __exports__